export default __webpack_public_path__ + "static/media/arrow.7f1bbdfd.svg";